// eslint-disable-next-line no-restricted-imports
import dayjs from 'dayjs'
import Duration from 'dayjs/plugin/duration'
import isBetween from 'dayjs/plugin/isBetween'
import IsSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import IsSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import RelativeTime from 'dayjs/plugin/relativeTime'
import Timezone from 'dayjs/plugin/timezone'
import Utc from 'dayjs/plugin/utc'

dayjs.extend(LocalizedFormat)
dayjs.extend(RelativeTime)
dayjs.extend(Duration)
dayjs.extend(Utc)
dayjs.extend(Timezone)
dayjs.extend(isBetween)
dayjs.extend(IsSameOrBefore)
dayjs.extend(IsSameOrAfter)

export const TIMEZONE_SG = 'Asia/Singapore'
export const TIMEZONE_JST = 'Asia/Tokyo'

export default dayjs

export const formatTime = (time: dayjs.ConfigType) => {
  if (!time) return
  const t = dayjs(time)
  if (t.isAfter(dayjs().subtract(1, 'd'))) return t.fromNow()
  return t.format('lll')
}

export function createTimeRange(
  name: string,
  opts?: {
    /**
     * Convert date to UTC before substraction
     * Useful for scenes like dailyClaim / freeGeneration which starts from UTC 00:00
     */
    isUTC?: boolean
  },
) {
  const now = opts?.isUTC ? dayjs().utc() : dayjs()
  // Example: Now is 03-10 12:00:00, Tue
  switch (name) {
    // From 03-10 00:00:00 (date)
    case 'today-exact':
      return { gt: now.startOf('day').toISOString() }
    // From 03-09 00:00:00 (date - 1) (actually yesterday)
    case 'today':
      return { gt: now.subtract(1, 'day').startOf('day').toISOString() }
    // From 03-07 00:00:00 (date - 7)
    case 'this-week':
      return { gt: now.subtract(1, 'week').startOf('day').toISOString() }
    // From 02-10 00:00:00 (month - 1)
    case 'this-month':
      return { gt: now.subtract(1, 'month').startOf('day').toISOString() }
    default:
      return undefined
  }
}
